var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Power = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.Power.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Power.prototype.init = function () {
  this._container;
  this._bar;
  this._barMask;

  if (this._container == null) {
    this._container = new EHDI.aka.Sprite(EHDI.Assets.images["meter_container"]);
    // this._container.anchor.set(0.5, 1);

    this.addChild(this._container);
  }

  if (this._bar == null) {
    this._bar = new EHDI.aka.Sprite(EHDI.Assets.images["meter_bar"]);
    // this._bar.anchor.set(0.49, 1.02);
    this._bar.x = 6;

    this.addChild(this._bar);
  }

  if (this._barMask == null) {
    this._barMask = new PIXI.Graphics();
    this._barMask.beginFill();
    this._barMask.drawRect(this._bar.x, this._bar.y, this._bar.width, this._bar.height);
    this._barMask.endFill();

    this._barMask.height = 0;
    this._barMask.y = this._bar.height;

    this._bar.mask = this._barMask;

    this.addChild(this._barMask);
  }
}

EHDI.game.Power.prototype.set = function (percentage) {
  if (this._tl != null)
    this._tl.kill();

  this._barMask.height = 0;
  this._barMask.y = this._bar.height;

  this._tl = TweenLite.to(this._barMask, 0.3,{y:this._bar.height * (1-percentage), height:this._bar.height * percentage});
}

EHDI.game.Power.prototype.reset = function () {
  if (this._tl != null)
    this._tl.kill();

  this._tl = TweenLite.to(this._barMask, 0.3,{y:this._bar.height, height:0});
}

EHDI.game.Power.prototype.destroy = function () {
  if (this._tl != null) {
    this._tl.kill();
    this._tl = null;
  }

  if (this._barMask != null) {
    this.removeChild(this._barMask);
    this._barMask = null;
  }

  if (this._bar != null) {
    this.removeChild(this._bar);
    this._bar = null;
  }

  if (this._container != null) {
    this.removeChild(this._container);
    this._container = null;
  }
}
